import { render, staticRenderFns } from "./VLangTabs.vue?vue&type=template&id=5252a9f6&"
import script from "./VLangTabs.vue?vue&type=script&lang=js&"
export * from "./VLangTabs.vue?vue&type=script&lang=js&"
import style0 from "./VLangTabs.vue?vue&type=style&index=0&id=5252a9f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports